import { useState } from "react";

const UploadFile = (props) => {
  const [uploadName, setUploadName] = useState(props.label || 'Upload Image');

  const handleFileChange = (e) => {
    const file = e.currentTarget.files[0];
    if (file) {
      setUploadName(file.name);
    }
    props.onChange(e);
  };

  return (
    <div className="uploadLogoContainer">
      <div className="uploadContainer">
        <input
          type="file"
          id={props.name}
          name={props.name}
          hidden
          onChange={handleFileChange}
          accept=".jpg,.png"
        />

        <label htmlFor={props.name}>UPLOAD</label>
        <span id={`fileChosen choosenFile`}>{uploadName}</span>
      </div>
      {props.formikTouch && props.formikErrors ? (
        <span className="errorText">{props.formikErrors}</span>
      ) : null}
    </div>
  );
};

export default UploadFile;
